<script lang="ts">
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';

	interface Props {
		isOpen: boolean;
		text: string;
	}

	const { isOpen, text }: Props = $props();
</script>

<SkeletonText
	text={text}
	tag="li"
	class="relative cursor-pointer overflow-hidden text-ellipsis flex-shrink-0 whitespace-nowrap p-2"
	ariaHidden={!isOpen}
/>
